// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.12.4
//   protoc               unknown
// source: qonto/registration/sms/firstparty/v1/send_sms.proto

/* oxlint-disable */

/** Request message for the SendSMS RPC. */
export interface ApiSendSMSRequest {
  /**
   * Name of the SMS template to use.
   * Valid values: "idnow-app-link", "qonto-verification-fourthline".
   */
  readonly templateName: string;
}

/** Response message for the SendSMS RPC. */
export interface ApiSendSMSResponse {
  /** Name of the SMS template that was used. */
  readonly templateName: string;
}

/** Custom error definitions for SendSMS. */
export interface ApiSendSMSErrors {
}

/** Bad request error codes (HTTP 400). */
export const ApiSendSMSErrorsBadRequestError = {
  /** BAD_REQUEST_ERROR_UNSPECIFIED - Unspecified bad request error. */
  BAD_REQUEST_ERROR_UNSPECIFIED: "BAD_REQUEST_ERROR_UNSPECIFIED",
  /** BAD_REQUEST_ERROR_STAKEHOLDER_IS_MISSING_PROVIDER_TOKEN - Stakeholder is missing the KYC provider token. */
  BAD_REQUEST_ERROR_STAKEHOLDER_IS_MISSING_PROVIDER_TOKEN: "BAD_REQUEST_ERROR_STAKEHOLDER_IS_MISSING_PROVIDER_TOKEN",
  /** BAD_REQUEST_ERROR_STAKEHOLDER_IS_MISSING_KYC_PROVIDER_ID - Stakeholder is missing the KYC provider ID. */
  BAD_REQUEST_ERROR_STAKEHOLDER_IS_MISSING_KYC_PROVIDER_ID: "BAD_REQUEST_ERROR_STAKEHOLDER_IS_MISSING_KYC_PROVIDER_ID",
} as const;

export type ApiSendSMSErrorsBadRequestError =
  typeof ApiSendSMSErrorsBadRequestError[keyof typeof ApiSendSMSErrorsBadRequestError];

export namespace ApiSendSMSErrorsBadRequestError {
  export type BAD_REQUEST_ERROR_UNSPECIFIED = typeof ApiSendSMSErrorsBadRequestError.BAD_REQUEST_ERROR_UNSPECIFIED;
  export type BAD_REQUEST_ERROR_STAKEHOLDER_IS_MISSING_PROVIDER_TOKEN =
    typeof ApiSendSMSErrorsBadRequestError.BAD_REQUEST_ERROR_STAKEHOLDER_IS_MISSING_PROVIDER_TOKEN;
  export type BAD_REQUEST_ERROR_STAKEHOLDER_IS_MISSING_KYC_PROVIDER_ID =
    typeof ApiSendSMSErrorsBadRequestError.BAD_REQUEST_ERROR_STAKEHOLDER_IS_MISSING_KYC_PROVIDER_ID;
}

export function apiSendSMSErrorsBadRequestErrorFromJSON(object: any): ApiSendSMSErrorsBadRequestError {
  switch (object) {
    case 0:
    case "BAD_REQUEST_ERROR_UNSPECIFIED":
      return ApiSendSMSErrorsBadRequestError.BAD_REQUEST_ERROR_UNSPECIFIED;
    case 1:
    case "BAD_REQUEST_ERROR_STAKEHOLDER_IS_MISSING_PROVIDER_TOKEN":
      return ApiSendSMSErrorsBadRequestError.BAD_REQUEST_ERROR_STAKEHOLDER_IS_MISSING_PROVIDER_TOKEN;
    case 2:
    case "BAD_REQUEST_ERROR_STAKEHOLDER_IS_MISSING_KYC_PROVIDER_ID":
      return ApiSendSMSErrorsBadRequestError.BAD_REQUEST_ERROR_STAKEHOLDER_IS_MISSING_KYC_PROVIDER_ID;
    default:
      return ApiSendSMSErrorsBadRequestError.BAD_REQUEST_ERROR_UNSPECIFIED;
  }
}

export function apiSendSMSErrorsBadRequestErrorToJSON(object: ApiSendSMSErrorsBadRequestError): string {
  switch (object) {
    case ApiSendSMSErrorsBadRequestError.BAD_REQUEST_ERROR_UNSPECIFIED:
      return "BAD_REQUEST_ERROR_UNSPECIFIED";
    case ApiSendSMSErrorsBadRequestError.BAD_REQUEST_ERROR_STAKEHOLDER_IS_MISSING_PROVIDER_TOKEN:
      return "BAD_REQUEST_ERROR_STAKEHOLDER_IS_MISSING_PROVIDER_TOKEN";
    case ApiSendSMSErrorsBadRequestError.BAD_REQUEST_ERROR_STAKEHOLDER_IS_MISSING_KYC_PROVIDER_ID:
      return "BAD_REQUEST_ERROR_STAKEHOLDER_IS_MISSING_KYC_PROVIDER_ID";
    default:
      return "BAD_REQUEST_ERROR_UNSPECIFIED";
  }
}

/** Not found error codes (HTTP 404). */
export const ApiSendSMSErrorsNotFoundError = {
  /** NOT_FOUND_ERROR_UNSPECIFIED - Unspecified not found error. */
  NOT_FOUND_ERROR_UNSPECIFIED: "NOT_FOUND_ERROR_UNSPECIFIED",
  /** NOT_FOUND_ERROR_STAKEHOLDER_NOT_FOUND - Stakeholder not found for the authenticated user. */
  NOT_FOUND_ERROR_STAKEHOLDER_NOT_FOUND: "NOT_FOUND_ERROR_STAKEHOLDER_NOT_FOUND",
} as const;

export type ApiSendSMSErrorsNotFoundError =
  typeof ApiSendSMSErrorsNotFoundError[keyof typeof ApiSendSMSErrorsNotFoundError];

export namespace ApiSendSMSErrorsNotFoundError {
  export type NOT_FOUND_ERROR_UNSPECIFIED = typeof ApiSendSMSErrorsNotFoundError.NOT_FOUND_ERROR_UNSPECIFIED;
  export type NOT_FOUND_ERROR_STAKEHOLDER_NOT_FOUND =
    typeof ApiSendSMSErrorsNotFoundError.NOT_FOUND_ERROR_STAKEHOLDER_NOT_FOUND;
}

export function apiSendSMSErrorsNotFoundErrorFromJSON(object: any): ApiSendSMSErrorsNotFoundError {
  switch (object) {
    case 0:
    case "NOT_FOUND_ERROR_UNSPECIFIED":
      return ApiSendSMSErrorsNotFoundError.NOT_FOUND_ERROR_UNSPECIFIED;
    case 1:
    case "NOT_FOUND_ERROR_STAKEHOLDER_NOT_FOUND":
      return ApiSendSMSErrorsNotFoundError.NOT_FOUND_ERROR_STAKEHOLDER_NOT_FOUND;
    default:
      return ApiSendSMSErrorsNotFoundError.NOT_FOUND_ERROR_UNSPECIFIED;
  }
}

export function apiSendSMSErrorsNotFoundErrorToJSON(object: ApiSendSMSErrorsNotFoundError): string {
  switch (object) {
    case ApiSendSMSErrorsNotFoundError.NOT_FOUND_ERROR_UNSPECIFIED:
      return "NOT_FOUND_ERROR_UNSPECIFIED";
    case ApiSendSMSErrorsNotFoundError.NOT_FOUND_ERROR_STAKEHOLDER_NOT_FOUND:
      return "NOT_FOUND_ERROR_STAKEHOLDER_NOT_FOUND";
    default:
      return "NOT_FOUND_ERROR_UNSPECIFIED";
  }
}

/** Too many requests error codes (HTTP 429). */
export const ApiSendSMSErrorsTooManyRequestsError = {
  /** TOO_MANY_REQUESTS_ERROR_UNSPECIFIED - Unspecified too many requests error. */
  TOO_MANY_REQUESTS_ERROR_UNSPECIFIED: "TOO_MANY_REQUESTS_ERROR_UNSPECIFIED",
  /** TOO_MANY_REQUESTS_ERROR_RATE_LIMIT - Rate limit exceeded (3 requests per hour). */
  TOO_MANY_REQUESTS_ERROR_RATE_LIMIT: "TOO_MANY_REQUESTS_ERROR_RATE_LIMIT",
} as const;

export type ApiSendSMSErrorsTooManyRequestsError =
  typeof ApiSendSMSErrorsTooManyRequestsError[keyof typeof ApiSendSMSErrorsTooManyRequestsError];

export namespace ApiSendSMSErrorsTooManyRequestsError {
  export type TOO_MANY_REQUESTS_ERROR_UNSPECIFIED =
    typeof ApiSendSMSErrorsTooManyRequestsError.TOO_MANY_REQUESTS_ERROR_UNSPECIFIED;
  export type TOO_MANY_REQUESTS_ERROR_RATE_LIMIT =
    typeof ApiSendSMSErrorsTooManyRequestsError.TOO_MANY_REQUESTS_ERROR_RATE_LIMIT;
}

export function apiSendSMSErrorsTooManyRequestsErrorFromJSON(object: any): ApiSendSMSErrorsTooManyRequestsError {
  switch (object) {
    case 0:
    case "TOO_MANY_REQUESTS_ERROR_UNSPECIFIED":
      return ApiSendSMSErrorsTooManyRequestsError.TOO_MANY_REQUESTS_ERROR_UNSPECIFIED;
    case 1:
    case "TOO_MANY_REQUESTS_ERROR_RATE_LIMIT":
      return ApiSendSMSErrorsTooManyRequestsError.TOO_MANY_REQUESTS_ERROR_RATE_LIMIT;
    default:
      return ApiSendSMSErrorsTooManyRequestsError.TOO_MANY_REQUESTS_ERROR_UNSPECIFIED;
  }
}

export function apiSendSMSErrorsTooManyRequestsErrorToJSON(object: ApiSendSMSErrorsTooManyRequestsError): string {
  switch (object) {
    case ApiSendSMSErrorsTooManyRequestsError.TOO_MANY_REQUESTS_ERROR_UNSPECIFIED:
      return "TOO_MANY_REQUESTS_ERROR_UNSPECIFIED";
    case ApiSendSMSErrorsTooManyRequestsError.TOO_MANY_REQUESTS_ERROR_RATE_LIMIT:
      return "TOO_MANY_REQUESTS_ERROR_RATE_LIMIT";
    default:
      return "TOO_MANY_REQUESTS_ERROR_UNSPECIFIED";
  }
}

export const ApiSendSMSRequest: MessageFns<ApiSendSMSRequest> = {
  fromJSON(object: any): ApiSendSMSRequest {
    return { templateName: isSet(object.template_name) ? globalThis.String(object.template_name) : "" };
  },

  toJSON(message: ApiSendSMSRequest): unknown {
    const obj: any = {};
    if (message.templateName !== undefined && message.templateName !== null) {
      obj.template_name = message.templateName;
    }
    return obj;
  },
};

export const ApiSendSMSResponse: MessageFns<ApiSendSMSResponse> = {
  fromJSON(object: any): ApiSendSMSResponse {
    return { templateName: isSet(object.template_name) ? globalThis.String(object.template_name) : "" };
  },

  toJSON(message: ApiSendSMSResponse): unknown {
    const obj: any = {};
    if (message.templateName !== undefined && message.templateName !== null) {
      obj.template_name = message.templateName;
    }
    return obj;
  },
};

export const ApiSendSMSErrors: MessageFns<ApiSendSMSErrors> = {
  fromJSON(_: any): ApiSendSMSErrors {
    return {};
  },

  toJSON(_: ApiSendSMSErrors): unknown {
    const obj: any = {};
    return obj;
  },
};

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

interface MessageFns<T> {
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
}
